/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field as ReduxFormField } from 'redux-form/immutable';

const Select = styled.select`
  width: 250px;
  height: 32px;
  padding-left: 10px;
  font-size: 13px;
  border-color: transparent;
  background-color: ${(props) => (props.disabled ? '#efefef' : 'inherit')};
  box-shadow: 0 1px 2px rgb(0 0 0 / 20%) inset, 0 -1px 0 rgb(0 0 0 / 5%) inset;
  cursor: pointer;
  &::placeholder {
    color: #404040;
  }
  &:focus {
    outline: 0;
    border-color: #3498db;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  }
`;

const SelectInput = ({ input, disabled, options, required, placeholder }) => (
  <Select {...input} disabled={disabled}>
    {options && (
      <Fragment>
        {!required && (
          <option value="" defaultValue disabled>
            {placeholder || 'Select filter...'}
          </option>
        )}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Fragment>
    )}
  </Select>
);

export const SelectInputField = (props) => {
  return <ReduxFormField {...props} component={SelectInput} />;
};

SelectInputField.propTypes = {
  name: PropTypes.string.isRequired,
  'data-automation': PropTypes.string,
};

SelectInput.propTypes = {
  input: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  options: PropTypes.array,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
